import React from 'react';

import Gravatar from '../../user/components/Gravatar';
import SearchResult from '../types/SearchResult';

const InstructorResultCell: React.FC<{ result: SearchResult }> = ({
  result,
}) => (
  <div className="flex items-center">
    <Gravatar
      email={result?.user?.email}
      internal={result?.user?.internal}
      isInstructor
    />
    <div className="ml-4">
      <div className="text-sm font-medium">{result.user.name}</div>
      <div className="text-sm text-gray-500">{result.user.email}</div>
    </div>
  </div>
);

export default InstructorResultCell;
